export default class RequestDemoButtons {
    constructor() {
        this.togglers = document.querySelectorAll('.request-popup-toggler');
        if (this.togglers) {
            this.addListeners();
        }
    }
    addListeners() {
        const that = this;
        this.togglers.forEach(toggler => {
            toggler.addEventListener('click',function(e){
                e.preventDefault();
                jQuery('.elementor-location-header .see-it-in-action-btn a').trigger('click');
            })
        })
    }
}